import { render, staticRenderFns } from "./Aspect.vue?vue&type=template&id=3e982394&scoped=true&"
import script from "./Aspect.vue?vue&type=script&lang=js&"
export * from "./Aspect.vue?vue&type=script&lang=js&"
import style0 from "./Aspect.vue?vue&type=style&index=0&id=3e982394&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e982394",
  null
  
)

export default component.exports